import * as React from "react"
import { cn } from "@/lib/utils"

type ResizeHandleProps = React.ComponentProps<"div">

/**
 * Vertical drag handle for resizable bottom panels.
 * Hit target / bar sizes come from --resize-handle-hit / --resize-handle-bar.
 */
function ResizeHandle({ className, ...props }: ResizeHandleProps) {
  return (
    <div
      data-slot="resize-handle"
      className={cn(
        // control geometry
        "flex h-[var(--resize-handle-hit)] w-full shrink-0 cursor-ns-resize items-center justify-center group",
        className,
      )}
      {...props}
    >
      <div
        // control geometry
        className="h-[var(--resize-handle-bar)] w-8 rounded-full bg-neutral-border-300 transition-colors duration-150 group-hover:bg-neutral-text-500"
      />
    </div>
  )
}

export { ResizeHandle }
